import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

const CheckIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className,
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className}`;

  return (
    <svg
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="check-icon"
      viewBox="0 0 17 13"
    >
      <path fill={fill || '#7E8A96'} d="M5.414 9.586l-4-4L0 7l5.414 5.414 11-11L15 0 5.414 9.586z" />
    </svg>
  );
};

export default CheckIcon;
